/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';

import { Form } from '@organisms';
import { DISABLED_CLASSNAME } from '@constants';

import AdditionColoursInputs from './AdditionColoursInputs';

const AdditionalColoursField = ({ className, name, label, rules, disabled, style, ...props }) => {
  return (
    <Form.Item
      name={name}
      rules={rules}
      label={label}
      disabled={disabled}
      style={style}
      className={clsx(className, disabled && DISABLED_CLASSNAME)}
    >
      <AdditionColoursInputs {...props} name={name} disabled={disabled} />
    </Form.Item>
  );
};

export default AdditionalColoursField;
